/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc
 */

export const getUserIdsOnHubByRoleIdAndPendingStatusRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'getUserIdsOnHubByRoleIdAndPendingStatus',
  auth: 'app',
  fingerprint: 'sPR9EE1FPIgBU2e0akw6AXSBKtGjviRU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const filterOutInvisibleUsersRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'filterOutInvisibleUsers',
  auth: 'app',
  fingerprint: 'z54Q9us7gedyyGwM-v7ZvXSBKtGjviRU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUsersByIdsRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'getUsersByIds',
  auth: 'app',
  fingerprint: '2zwwN0u_84e7bEiN-TP8SnSBKtGjviRU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setUserPermissionsRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'setUserPermissions',
  auth: 'app',
  fingerprint: 'rRqFJl3z6U8cP0Fcwuzm6HSBKtGjviRU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setUserPermissionsAndSeatsRpc = {
  serviceName: 'com.hubspot.appusers.rpc.UsersRpc',
  rpcName: 'setUserPermissionsAndSeats',
  auth: 'app',
  fingerprint: 'LJfIKn4X6sLM3mKaBBaHTHSBKtGjviRU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};